import FooterControl from '@/components/FooterControl.vue';

import medicinePrint from '@/components/medicinePrint/index.vue';
import receiptPrint from '@/components/receiptPrint/index.vue'; // 小票打印
import piecesPrint from '@/components/piecesPrint/index.vue'; // 饮片打印
import infusionPrint from '@/components/infusionPrint/index.vue'; // 输液打印
import applyPrint from '@/components/applyPrint/index.vue'; // 敷贴打印
import otherPrint from '@/components/otherPrint/index.vue'; // 其他打印
import infusionCardPrint from '@/components/infusionCardPrint/index.vue'; // 输液打印卡
import recordPrint from '@/components/recordPrint/index.vue'; // 病历打印
import noPrintTips from '@/components/noPrintTips.vue';
import print from './print';
import config from '@/config/index';


export default {
  components: { FooterControl, medicinePrint, receiptPrint, piecesPrint, infusionPrint, infusionCardPrint, applyPrint, otherPrint, noPrintTips, recordPrint },
  mixins: [print],
  data() {
    return {
      htmlTitle: '病历',
      uploadUrl: `${config.host}/upload/oss/upload`, // 上传病历地址
      fileList2: [], // 上传病历附件
      tableDatas: {
        patient: {
        }, // 患者信息
        inquiryInfo: {

        }, // 病历信息
        additionalList: [], // 附加费用集合
        examList: [], // 检查治疗项集合
        medicineDrugPrescriptionList: [], // 西药处方集合
        patientChineseDrugList: [], // 中药处方集合
        patientInfusionList: [], // 输液处方集合
        patientStickingDrugGroupList: [], // 贴敷处方集合
      },
      recordId: parseInt(this.$route.query.id, 10),
      // review: false,
      delFiles: [], // 删除的病历附件
      isChangeFiles: false, // 是否修改了附件
    };
  },
  methods: {
    getTableData() {
      this.$api.outPatient.getRecord({
        recordId: this.recordId,
      }).then((res) => {
        this.tableDatas = res;
        console.log(res);
        const time = this.tableDatas.inquiryInfo.clinicalTime.replace(/-/g, '');
        this.htmlTitle = `${this.tableDatas.patient.patientName}-${time}-${this.recordId}`;
        // 打印需要的数据
        this.record = res;
        this.record.patient.clinicalTime = this.record.inquiryInfo.clinicalTime; // 诊断时间
        this.record.inquiryInfo.doctorName = this.$store.state.global.countInfo.doctorName; // 医生信息
        if (this.record.inquiryInfo.inquiryAttachmentList && this.record.inquiryInfo.inquiryAttachmentList.length > 0) {
          this.fileList2 = this.record.inquiryInfo.inquiryAttachmentList.map(item => ({
            name: `${item.fileName}.${item.fileType}`,
            url: item.newUri,
          }));
        }
      });
    },
    goback() {
      this.$router.go(-1);
      // this.$router.push({ path: 'caseHistory' });
    },
    down() {
      this.$api.outPatient.down();
    },
    isImg(type) {
      let isImages = false;
      const imgType = ['bmp', 'jpg', 'png', 'jpeg'];
      if (imgType.includes(type)) {
        isImages = true;
      }
      return isImages;
    },
    // 删除病历附件-后台删除
    delteteFiles() {
      this.$api.outPatient.deleteFile({
        ossUrlList: this.delFiles,
      }).then(() => {
      });
    },
    // 删除病历附件-页面删除
    handleRemove(file) {
      console.log(file);
      this.delFiles.push(file.url);
      const list = this.fileList2.filter((item) => {
        return item.url !== file.url;
      });
      this.fileList2 = list;
      console.log(this.fileList2);
      this.isChangeFiles = true;
    },
    beforeAvatarUpload(file) {
      const isFile = file.type === 'image/jpeg' || file.type === 'application/msword' || file.type === 'image/bmp' || file.type === 'image/png' || file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      const isLt2M = file.size / 1024 / 1024 < 5;
      console.log(file.type);
      if (!isFile) {
        this.$message.error('请检查附件格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      return isFile && isLt2M;
    },
    // 上传病历成功
    handleAvatarSuccess(res, file) {
      console.log(file);
      const files = JSON.parse(file.response);
      // let arr = '';
      if (files.errorCode === 0 && files.data.length > 0) {
        // arr = files.data[0].split('/').pop();
        this.fileList2.push({
          name: file.name,
          url: files.data[0],
        });
      } else {
        this.$message.error('上传失败!');
        console.log(file);
        this.fileList2.pop();
      }
      this.isChangeFiles = true;
    },
    // 上传文件超过限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      window.open(file.url, 'target');
    },
    // 保存附件
    saveFiles() {
      // 上传附件格式
      const inquiryAttachmentList = this.fileList2.map(item => ({
        fileName: item.name.substring(0, item.name.lastIndexOf('.')),
        fileType: item.name.substring(item.name.lastIndexOf('.') + 1),
        newUri: item.url,
      }));
      this.$api.outPatient.saveInquiryAttachment({
        recordId: this.recordId,
        patientId: this.tableDatas.patient.patientId,
        inquiryAttachmentList,
      }).then((res) => {
        console.log(res);
        this.$message({
          message: '保存成功',
          type: 'success',
        });
        // 删除附件
        if (this.delFiles.length > 0) {
          this.delteteFiles();
        }
      });
    },
    // 打印预览
    printReview(name) {
      this.$notify({
        title: '提示',
        message: '正在打开预览...',
        type: 'success',
      });
      if (name === 'medicineDrugPrescriptionList') this.$refs.medicinePrint.print({ isReview: true });
      if (name === 'patientChineseDrugList') this.$refs.piecesPrint.print({ isReview: true });
      if (name === 'patientInfusionList') this.$refs.infusionPrint.print({ isReview: true });
      if (name === 'patientStickingDrugGroupList') this.$refs.applyPrint.print({ isReview: true });
    },
  },
  mounted() {
    this.getTableData();
  },
  filters: {
    setPosition(info) {
      console.log(info);
      let newInfo = JSON.parse(info);
      console.log(newInfo);
      if (newInfo.length > 0) {
        newInfo = newInfo.join(' ');
      } else {
        newInfo = '';
      }
      return newInfo;
    },
  },
};
